import Service, { inject as service } from '@ember/service';

export default Service.extend({
  api: service(),

  /**
   * @param {User} user
   * @return {Ember.RSVP.Promise}
   */
  getAllPayoutMethods(user) {
    const endpoint = `/users/${user.get('id')}/payout-methods`;
    const options = {};

    return this.get('api').request(endpoint, options);
  },
});
